import dayjs from 'dayjs';
export const monthNames = () => { return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']; };
export const dayOptions = (day, month, year, includeDay, showDaysOfTheWeekHeader = false, minDate = null) => {
    if (!includeDay)
        return null;
    const days = [];
    for (let i = 1; i <= 31; i++) {
        days.push(i);
    }
    const monthNumber = Number(month);
    const lastDayOfMonth = new Date(Number(year), monthNumber + 1, 0).getDate();
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    const currentDay = today.getDate();
    const minDateYear = minDate ? minDate.getFullYear() : null;
    const minDateMonth = minDate ? minDate.getMonth() : null;
    const minDateDay = minDate ? minDate.getDate() : null;
    return { optionName: 'day', miniButtons: true, skipOptionText: "I don't know", showDaysOfTheWeekHeader: showDaysOfTheWeekHeader, optionList: days.map(dayValue => ({ text: dayValue, value: dayValue, active: day == dayValue, disabled: // February non-leap year check and future month check
            (Number(year) % 4 !== 0 || Number(year) % 100 === 0 && Number(year) % 400 !== 0) && month == 1 && dayValue == 29 || dayValue > lastDayOfMonth || // Disable future days in the current month of the current year
                Number(year) === currentYear && Number(month) === currentMonth && dayValue > currentDay || // Disable days before the minimum date (if in the same year and month)
                Number(year) === minDateYear && Number(month) === minDateMonth && dayValue < minDateDay })) };
};
export const monthOptions = (month, year, includeDay, minDate = null) => { const today = new Date(); const currentYear = today.getFullYear(); const currentMonth = today.getMonth(); const minDateYear = minDate ? minDate.getFullYear() : null; const minDateMonth = minDate ? minDate.getMonth() : null; return { optionName: 'month', loadDisabled: includeDay, disabledOptionTitle: 'This is not valid with the selected day and month', optionList: monthNames().map((monthValue, index) => ({ text: monthValue.substring(0, 3), value: index, disabled: Number(year) === currentYear && index > currentMonth || Number(year) === minDateYear && index < minDateMonth, active: month === index })) }; };
export const yearOptions = (year, minDate, minYear, maxYear) => { const currentYear = new Date().getFullYear(); const minDateYear = minDate ? minDate.getFullYear() : minYear; const years = []; for (let i = maxYear; i >= Math.max(minYear, minDateYear); i--) {
    years.push(i);
} return { optionName: 'year', previousText: 'Later', nextText: 'Earlier', loadDisabled: true, disabledOptionTitle: 'This is not valid with the selected day/month', optionList: years.map(yearValue => ({ text: yearValue, value: yearValue, disabled: currentYear < yearValue || minDateYear > yearValue, active: year == yearValue })) }; };
export const buildDate = (day, month, year, defaultDay) => {
    if (!year) {
        return null;
    }
    if (!day) {
        if (defaultDay === 'last') {
            day = new Date(Number(year), Number(month) + 1, 0).getDate(); // The last day of the month.
        }
        else {
            day = 1; // The first day of the month.
        }
    }
    return new Date(Number(year), Number(month), Number(day));
};
export const dateInputValue = (day, month, year) => { if (!year) {
    return '';
} return day ? `${day} ${monthNames()[Number(month)]} ${year}` : `${monthNames()[Number(month)]} ${year}`; };
export const datePickerDateOptions = (day, month, year, minDate, minYear, maxYear, includeDay, showDaysOfTheWeekHeader = false) => { return [yearOptions(year, minDate, minYear, maxYear), monthOptions(month, year, includeDay, minDate), dayOptions(day, month, year, includeDay, showDaysOfTheWeekHeader, minDate)].filter(Boolean); };
export const areSameDates = (date1, date2) => { if (!date1 || !date2) {
    return false;
} return date1.getTime() === date2.getTime(); };
export function getRangeDuration(startDate, endDate, includeWeeks = false) {
    const diff = dayjs(endDate).diff(dayjs(startDate));
    const unroundedYears = dayjs.duration(diff).as('years');
    let roundedYears = Math.floor(unroundedYears || 0);
    const unroundedMonths = dayjs.duration(diff).subtract(roundedYears, 'year').as('months');
    let roundedMonths = Math.round(unroundedMonths || 0);
    if (includeWeeks) {
        const unroundedWeeks = dayjs.duration(diff).subtract(roundedYears, 'year').subtract(roundedMonths, 'month').as('weeks');
        let roundedWeeks = Math.round(unroundedWeeks || 0); // Sometimes we'll end up with dates like 3 months, and 4 weeks
        // due to the rounding above, in that case we do a little manual
        // correction:
        if (roundedWeeks === 4) {
            roundedMonths++;
            roundedWeeks = 0;
        }
        else if (roundedWeeks === -1) {
            roundedMonths--;
            roundedWeeks = 3;
        }
        if (roundedMonths === 12) {
            roundedYears++;
            roundedMonths = 0;
        }
        return { years: roundedYears, months: roundedMonths, weeks: roundedWeeks };
    } // Sometimes we'll end up with dates like 3 years, and 12 months
    // due to the rounding above, in that case we do a little manual
    // correction:
    if (roundedMonths === 12) {
        roundedYears++;
        roundedMonths = 0;
    }
    return { years: roundedYears, months: roundedMonths };
}
export function parseDate(dateString, fallback = null) { if (!dateString) {
    return fallback || null;
} return new Date(dateString); }
export function shortDateString(date) { return dayjs(date).format('D MMM YYYY'); }
export function dateRangeString(startDate, endDate) { return `${shortDateString(startDate)} - ${endDate ? shortDateString(endDate) : 'Now'}`; }
export function inDateRange(date, rangeStartDate, rangeEndDate) {
    if (!date || !rangeStartDate || !rangeEndDate) {
        throw 'Expected all parameters to be supplied.';
    } // https://day.js.org/docs/en/query/is-between
    return dayjs(date).isBetween(dayjs(rangeStartDate), dayjs(rangeEndDate), 'day', '[]');
}
